import ClipboardJS from "clipboard";
import nativeToast from "native-toast";
import "native-toast/dist/native-toast.css";

export default selector => {
  const clipboard = new ClipboardJS(selector);

  clipboard.on("success", e => {
    nativeToast({
      message: "Copied to Clipboard!",
      position: "south-west"
    });
  });
};
